// extracted by mini-css-extract-plugin
module.exports = {"breadCrumbs":"breadCrumbs__breadCrumbs--2pkcX","separator":"breadCrumbs__separator--1lPqL","link":"breadCrumbs__link--1TY6b"};